import { render } from "./TableErrori.vue?vue&type=template&id=e60b7f96&ts=true"
import script from "./TableErrori.vue?vue&type=script&lang=ts"
export * from "./TableErrori.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/AreaClienti_SELENIA/AreaClienti_SELENIA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__